/**
 * NetworkOverview — `/network` route.
 *
 * Body is now the hand-built design from `network-overview.html`
 * (rendered verbatim via the `NetworkOverviewHero` component / shared
 * `PageHost` wrapper).
 *
 * Navbar and Footer are unchanged: this page keeps importing and
 * rendering the existing site Navbar and Footer per the user's rule.
 */
import { Helmet } from "react-helmet-async";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { NetworkOverviewHero } from "../components/NetworkOverviewHero";

export default function NetworkOverview() {
  return (
    <main className="min-h-screen bg-aubergine" data-testid="network-overview-page">
      <Helmet>
        <title>T-REX Network : Three pillars. One ecosystem. One standard.</title>
      </Helmet>
      <Navbar />
      {/* Spacer to clear the fixed Navbar so the hero begins below it. */}
      <div aria-hidden="true" style={{ height: 64 }} />
      <NetworkOverviewHero />
      <Footer />
    </main>
  );
}
